export const surveyWoundDetailsActions = {
  populateSurveyWoundDetails: "POPULATE_SURVEY_WOUND_DETAILS",
  surveyWoundDetailsLoading: "DATA_SURVEY_WOUND_DETAILS_LOADING",
  surveyWoundDetailsLoadError: "DATA_SURVEY_WOUND_DETAILS_LOAD_ERROR"
};
